import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/edge-gateways/$id/settings")({
  staticData: {
    title: "edge.navigation.settings",
  },
});
